import cn from 'classnames';
import DropdownSort from 'components/StudioSearchPage/StudioSearchResults/DropdownSort/DropdownSort';
import ItemsLoadingSpinner from 'components/StudioSearchPage/StudioSearchResults/ItemsLoadingSpinner/ItemsLoadingSpinner';
import SearchResultsGallery from 'components/StudioSearchPage/StudioSearchResults/SearchResultsGallery/SearchResultsGallery';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import getStudioSearchResults from 'store/studioSearch/selector/getStudioSearchResults';
import isStudioSearchLoading from 'store/studioSearch/selector/isStudioSearchLoading';
import OpStepper, { OpStepperItem } from 'components/Common/op-ui-wrappers/OpStepper/OpStepper';
import { useTranslation } from 'react-i18next';
import DropdownFilters from './DropdownFilters/DropdownFilters';
import LoadMoreItems from './LoadMoreItems/LoadMoreItems';
import SearchSummary from './SearchSummary/SearchSummary';
import styles from './StudioSelectionSearchResults.module.scss';

const ActionBar: FC = () => {
  return (
    <div className={styles.actionBar}>
      <DropdownFilters />
      <div className={styles.divider} />
      <DropdownSort />
    </div>
  );
};

const StudioSelectionSearchResults = () => {
  const isLoading = useSelector(isStudioSearchLoading);
  const searchResults = useSelector(getStudioSearchResults);
  const { t } = useTranslation();

  const stepperItems: OpStepperItem[] = [
    {
      label: `${t('txt_choose_any_image')}`,
      icon: 'thumbnail',
    },
    {
      label: `${t('txt_select_product')}`,
      icon: 'products',
    },
    {
      label: `${t('txt_print_your_own_designs')}`,
      icon: 'image-special',
    },
  ];

  if (!searchResults.length) {
    return (
      <div className={cn(styles.itemsWrapper)}>
        <ItemsLoadingSpinner isLoading={isLoading} />
      </div>
    );
  }

  return (
    <div className={cn(styles.itemsWrapper, 'productsWrapper', { [styles.loading]: isLoading })}>
      <SearchSummary />
      <div className={styles.stepper}>
        <OpStepper items={stepperItems} />
      </div>
      <ActionBar />
      <SearchResultsGallery isLoading={isLoading} items={searchResults} />
      <LoadMoreItems />
    </div>
  );
};

export default StudioSelectionSearchResults;
